import React from 'react';
import Axios from 'axios';
import { ConnectedUserContext } from '../../connectedUser-context';
import { withRouter } from "../../withRouter"; 	// HOC pour React Router v6

import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';
import { Checkbox, FormControlLabel } from "@mui/material";

import moment from 'moment';

import QvneaBooksOperationModal from './QvneaBooksOperationModal';

const cstQBooksAdmins = [
{user: "Patrick Poulin", shortname: "Pat"},
{user: "patrick.poulin@gmail.com", shortname: "Pat"},
{user: "Marco Sanschagrin", shortname: "Marco"},
{user: "sanschagrinmarco@gmail.com", shortname: "Marco"},
{user: "Cynthia Pelletier", shortname: "Cyn"},
{user: "pelletier_cyn@hotmail.com", shortname: "Cyn"},
{user: "Pascal Grenier", shortname: "Pascal"},
{user: "pascal_grenier@hotmail.com", shortname: "Pascal"},
{user: "Serge Fournier", shortname: "Serge"},
{user: "AJOUTER_UNE_ENTRÉE_COURRIEL_POUR_SERGE", shortname: "Serge"},
];

/*
db.seasons.update({}, {$set: {special: ""}}, false, true)
db.seasons.update({}, {$set: {membershipcardSeasonId: "0"}}, false, true)
db.seasons.update({name: /QVNEA - CARTE DE MEMBRE/}, {$set: {special: "MEMBERSHIPCARD SEASON"}}, false, true)
*/

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

const cstTableHeaders = ['#', 'Date', 'Joueur', 'Operation', 'Ligue / Season', 'Débit', 'Crédit', 'Notes', 'Admin'];	//, 'Semaine', 'Mois'];
const cstDefaultSortOrder = ['desc', 'desc', '', 'asc', '', 'desc', 'desc', 'asc', 'asc'];	//, 'desc', 'desc'];
const cstDefaultSortFieldIdx = 0;

const TABLE_NBCOL = 9;
const PAGER_DISPPAGES = 5;
const PAGER_PAGESIZE = 20;

const CST_IDX_PADDING_SIZE = 7;


class QvneaBooksOperations extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			operTypes: [],
			leagues: [],
			leaguesQvneaBooks: [],
			seasons: [],

			operations: [],
			subtotal: 0,

			dataFilters: {
				filteredResults: false,
				dateA: "",
				dateB: "",
				playerId: "0",
				type: "",
				leagueId: "0",
				seasonId: "0",
				notes: "",
				showDeleted: false
			},

      sortParams: {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			},
			pager: {
				startIndex: 0,
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				endIndex: PAGER_PAGESIZE - 1,
				totalItems: 0
			},
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],

			prevValidDateA: '',
			prevValidDateB: '',

			showQvneaBooksEditModal: false,
			modalOperation: {
				operationId: '0',
				playerId: '0',
				playerIdTx: '0',
				leagueId: '0',
				seasonId: '0',
				leagueIdTx: '0',
				seasonIdTx: '0',
				type: '',
				date: '',
				notes: '',
				deleted: false
			},

			showDeleted: false,
			loading: true,
		};

    this.handleSortTable = this.handleSortTable.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);

    this.handlePlayerChange = this.handlePlayerChange.bind(this);
    this.handlePlayerOnBlur = this.handlePlayerOnBlur.bind(this);

		this.handleDateAChange = this.handleDateAChange.bind(this);
		this.handleDateBChange = this.handleDateBChange.bind(this);
		this.handleDateABlur = this.handleDateABlur.bind(this);
		this.handleDateBBlur = this.handleDateBBlur.bind(this);
		this.handleOperChange = this.handleOperChange.bind(this);
		this.handleLeagueChange = this.handleLeagueChange.bind(this);
		this.handleSeasonChange = this.handleSeasonChange.bind(this);
		this.handleNotesChange = this.handleNotesChange.bind(this);
    this.handleShowDeletedChange = this.handleShowDeletedChange.bind(this);

    this.handleApplyFilters = this.handleApplyFilters.bind(this);
    this.handleResetFilters = this.handleResetFilters.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleShowProcedure = this.handleShowProcedure.bind(this);
    this.handleDownloadOperationsCSV = this.handleDownloadOperationsCSV.bind(this);

		this.createTableRow = this.createTableRow.bind(this);
    this.reloadData = this.reloadData.bind(this);
	}

	componentDidMount() {
		//console.log('QvneaBooksOperations: componentDidMount');
		this.initiateData();
		this.initiatePagerSizeWithData(this.state.dataFilters, true);
	}

	initiateData() {
		var dataFilters = this.state.dataFilters;
		if (localStorage.getItem('filtPlayerId') !== null) {
			dataFilters.playerId = localStorage.getItem('filtPlayerId');
		}

		Axios.get('/api/qvneaBooks/operationTypes').then(responseOperTypes => {
		Axios.get('/api/leagues/').then(responseLeagues => {
		Axios.get('/api/leagues/qvneaBooks').then(responseLeaguesQvneaBooks => {

  		// generate Years selector
			this.setState({
				dataFilters: dataFilters,
				operTypes: responseOperTypes.data,
				leagues: responseLeagues.data,
				leaguesQvneaBooks: responseLeaguesQvneaBooks.data
			});
		});
		});
		});
	}

	loadSeasons() {
		var dataFilters = this.state.dataFilters;
		Axios.get('/api/seasons/leagueId/' + dataFilters.leagueId).then(responseSeasons => {
			var seasons = responseSeasons.data;
			dataFilters.seasonId = "0";
			this.setState({ 
				seasons: seasons,
				dataFilters: dataFilters
			});
		});
	}

	initiatePagerSizeWithData(dataFilters, resetSorting) {
		var sortParams = {
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			sortClass: []
		}
		if (!resetSorting) {
			sortParams = this.state.sortParams;
		}

		sortParams.sortClass = [];
		for(var i = 1; i < (TABLE_NBCOL - 1); i++) {
			sortParams.sortClass[i] = '';
		}
		sortParams.sortClass[sortParams.sortFieldIdx] = "statelo-sorting_" + sortParams.sortOrder;

		// Init pager
		var pager = {
			totalPages: 1,
			pages: [1],
			currentPage: 1,
			pageSize: this.state.pager.pageSize,
			startindex: 0,
			endIndex: this.state.pager.pageSize-1,
			totalItems: 0,
		};

		// Set start date on chart
		var filtDateA = dataFilters.dateA;
    if (filtDateA === "") {
    	filtDateA = "ALL";
			//dataFilters.dateA = moment(new Date('2021-01-01')).utc().format("YYYY-MM-DD");
    }
		// Set end date on chart
		var filtDateB = dataFilters.dateB;
    if (filtDateB === "") {
    	filtDateB = "ALL";
      //dataFilters.dateB = moment().utc().format("YYYY-MM-DD");	// today
    }

		this.setState({
			prevValidDateA: dataFilters.dateA,
			prevValidDateB: dataFilters.dateB
		});

		var filtOper = dataFilters.type.trim();
		if (filtOper === '') {
			filtOper = "ALL";
		}

		var filtNotes = dataFilters.notes.trim();
		if (filtNotes === '') {
			filtNotes = "ALL";
		}

		var filtDeleted = !dataFilters.showDeleted;

		Axios.get('/api/qvneaBooks' + 
			'/filtDates/' + filtDateA + '/' + filtDateB + 
			'/filtPlayer/' + dataFilters.playerId + 
			'/filtOper/' + filtOper + 
			'/filtLeague/' + dataFilters.leagueId + 
			'/filtSeason/' + dataFilters.seasonId + 
			'/filtNotes/' + filtNotes + 
			'/filtDeleted/' + filtDeleted + 
			'/count').then(response => {

			// console.log('GET count');
			// console.log(response.data);
			this.setState({
				subtotal: response.data.subtotal
			})

			pager.totalItems = response.data.count;
			this.setPage(1, pager, sortParams);
		});
	}

  setPage(page, pager, sortParams) {

		// set optional parameters
    // var pager = pager || this.state.pager;
    pager = (pager === undefined) ? this.state.pager : pager;

    if ((page < 1) || (page > pager.totalPages)) {
    	console.log('ERR: setPage unexpected return');
    	return;
    }
    sortParams = (sortParams === undefined) ? this.state.sortParams : sortParams;

    // get new pager object for specified page
    pager = this.getPager(pager.totalItems, page, pager.pageSize);

    // call change page function in parent component
    this.loadData(pager, sortParams);
  }

  getPager(totalItems, currentPage, pageSize) {

    // default to first page
    // currentPage = currentPage || 1;
    // currentPage = (currentPage === undefined) ? 1 : currentPage;
 
    // default page size is 10
    // calculate total pages
    // pageSize = (pageSize === undefined) ? PAGER_PAGESIZE : pageSize;
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= PAGER_DISPPAGES) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= ((PAGER_DISPPAGES / 2) + 1)) {
        startPage = 1;
        endPage = PAGER_DISPPAGES;
      } else if (currentPage + ((PAGER_DISPPAGES / 2) - 1) >= totalPages) {
        startPage = totalPages - (PAGER_DISPPAGES - 1);
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
        endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
 
    // create an array of pages to ng-repeat in the pager control
    // var pages = _.range(startPage, endPage + 1);		// lodash function
 		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) {
	  	return index + startPage;  
  	});

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

	loadData(pager, sortParams) {
		var dataFilters = this.state.dataFilters;

		// Set start date on chart
		var filtDateA = dataFilters.dateA;
    if (filtDateA === "") {
    	filtDateA = "ALL";
    }
		// Set end date on chart
		var filtDateB = dataFilters.dateB;
    if (filtDateB === "") {
    	filtDateB = "ALL";
    }

		var filtOper = dataFilters.type.trim();
		if (filtOper === '') {
			filtOper = "ALL";
		}

		var filtNotes = dataFilters.notes.trim();
		if (filtNotes === '') {
			filtNotes = "ALL";
		}

		var filtDeleted = !dataFilters.showDeleted;

		Axios.get('/api/qvneaBooks' + 
			'/filtDates/' + filtDateA + '/' + filtDateB + 
			'/filtPlayer/' + dataFilters.playerId + 
			'/filtOper/' + filtOper + 
			'/filtLeague/' + dataFilters.leagueId + 
			'/filtSeason/' + dataFilters.seasonId + 
			'/filtNotes/' + filtNotes + 
			'/filtDeleted/' + filtDeleted + 
			'/start/' + pager.startIndex + 
			'/end/' + (pager.endIndex + 1) + 
			'/sortFieldIdx/' + sortParams.sortFieldIdx + 
			'/sortOrder/' + sortParams.sortOrder)
			.then(response => {

				var operations = response.data;

				//console.log('operations');
				//console.log(operations);

				// build data
				this.buildOperationsTable(operations, pager, sortParams);
		});	
	}

	buildOperationsTable(operations, pager, sortParams) {
		// unspecified parameters -> take state
		pager = (pager === undefined) ? this.state.pager : pager;
		sortParams = (sortParams === undefined) ? this.state.sortParams : sortParams;

		// console.log('operations');
		// console.log(operations);

		this.setState({
			operations: operations,
			pager: pager,
			sortParams: sortParams,
			loading: false,
		});
	}

	reloadData() {
		this.initiatePagerSizeWithData(this.state.dataFilters, false);
	}

	render() {
		// console.log('QvneaBooksOperations: render');
		// console.log(this.state, this.props);
    var pager = this.state.pager;

		return (
			<div className="animated fadeIn">

        <div className="row">
        <div className="col-md-10 col-xs-12">
        	<h4>QVNEA Books - Gestion des opérations</h4>
        	<ul className="ul-left-aligned">
        		<li>Entrer les opérations de débit ou de crédit pour chaque joueur</li>
        		<li>Spécifier la ligue (ou le compte) et la saison</li>
        		<li>Filtrer les résultats selon les critères voulus afin d'obtenir un solde par dates/joueur/opération</li>
        		<li>Modifier une entrée en cliquand sur l'icône d'édition à gauche de cette dernière ou en double-cliquant sur cette entrée</li>
        	</ul>
					<button className="btn btn-primary" 
						onClick={this.handleShowProcedure}>
						Procédure de gestion QVNEA (.pdf)
					</button>
				</div>
				</div>
				<hr/>

				<div className="row">
				<div className="col-12">
					<strong className="font-weight-bold">FILTRES</strong>
					<div className="row">
						{this.dispDateFilterA()}
						{this.dispDateFilterB()}
					</div>
					<div className="row">
						{this.dispPlayerSearch()}
						{this.dispOperFilter()}
					</div>
					<div className="row">
						{this.dispLeagueFilter()}
						{this.dispSeasonFilter()}
						{this.dispNotesFilter()}
					</div>


					<div className="row margin-top-10">
		      <div className="col-12">
						<FormControlLabel
						  control={
						    <Checkbox
						      color="success" checked={this.state.dataFilters.showDeleted || false}
						      onChange={this.handleShowDeletedChange} />
						  }
						  label="Afficher les opérations supprimées"
						/>
					</div>
					</div>

					<button className="btn btn-sm btn-primary btn-margin-topbottom-10 btn-margin-right-20 btn-extra-padding" 
						onClick={this.handleApplyFilters}>
						Appliquer les filtres
					</button>
					<button className="btn btn-sm btn-primary btn-margin-topbottom-10 btn-margin-right-20 btn-extra-padding" 
						onClick={this.handleResetFilters}>
						Supprimer les filtres
					</button>

					<button className="btn btn-sm btn-primary btn-margin-topbottom-10 btn-extra-padding" 
						onClick={this.handleAddEditOperationClick.bind(this, {_id: "0"})}>
						Nouvelle opération
					</button>
				</div>
				</div>
				<hr/>

				<div className="row">
        <div className="col-12">
        	<h5>TABLE DES OPÉRATIONS</h5>
				</div>
				</div>

				{(this.state.loading) ?
					this.displaySpinner() : 
					this.displayModule(pager)
				}

				<br/><br/><br/>

				{/* Modal */}
				<QvneaBooksOperationModal 
					className = {this.props.className}
					showModal = {this.state.showQvneaBooksEditModal}
					modalOperation = {this.state.modalOperation}
					handleModalCancel = {this.handleModalCancel}
					reloadData = {this.reloadData}
					operTypes = {this.state.operTypes}
					leagues = {this.state.leaguesQvneaBooks}
				/>

      </div>
		);
	}

	displayModule(pager) {
		return (
			<div className="row">
			<div className="col-12">

				<div className="row">
				<div className="col-sm-6 col-12">
					<span className="subtotal1">Solde: </span><span className="subtotal2">{this.state.subtotal.toFixed(2)} $</span>
				</div>
				<div className="col-6 text-right">
					<button className="btn btn-primary btn-sm" 
						onClick={this.handleDownloadOperationsCSV}>
						<i className="fa fa-download"></i> Télécharger toutes les opérations
					</button>
				</div>
				</div>

				<div className="row">
				<div className="col-12">
					{this.state.dataFilters.filteredResults ? 
						<strong>(résultats filtrés)</strong> :
						<strong></strong>
					}
				</div>
				</div>

				<div className="row">
				<div className="col-12">
					{this.displayData(pager)}
				</div>
				</div>

				<div className="row">
				<div className="col-sm-6 col-12">
					{this.displayPagination(pager)}
					<i>{pager.totalItems} élément{(pager.totalItems>1)?'s ':' '} 
					dans {pager.totalPages} page{(pager.totalPages>1)?'s':''}</i>
				</div>
				</div>

				<div className="row">
				<div className="col-xl-3 col-md-4 col-sm-6 col-9">
		  		<select className="form-control form-control-sm input-sm" name="pagesize" id="pagesize" 
		  			value={this.state.pagesize} onChange={this.handlePageSizeChange}>
						<option value={20} key={'ot1'}> 20 éléments par page </option>
						<option value={100} key={'ot2'}> 100 éléments par page</option>
						<option value={500} key={'ot3'}> 500 éléments par page</option>
					</select>
				</div>
				</div>

	    </div>
	    </div>
    );
	}

	displayData(pager) {
		var sortClass = this.state.sortParams.sortClass;

		return (
			<div>
			<div className="table-responsive">
			<table className="table table-hover table-sm">
			<thead>
				<tr>
					<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable} width="6%"> #	</th>
					<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable} width="8%"> Date	</th>
					<th id='hdr.2' width="15%"> Joueur </th>
					<th id='hdr.3' className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable} width="12%"> Opération </th>
					<th id='hdr.4' width="24%"> Ligue / Compte </th>
					<th id='hdr.5' className={"text-right statelo-sorting " + sortClass[5]} 
						onClick={this.handleSortTable} width="8%">Débit</th>
					<th id='hdr.6' className={"text-right statelo-sorting " + sortClass[6]} 
						onClick={this.handleSortTable} width="8%">Crédit</th>
					<th id='hdr.7' className={"cellPaddingLeft statelo-sorting " + sortClass[7]} onClick={this.handleSortTable}> Note </th>
					<th id='hdr.8' className={"statelo-sorting " + sortClass[8]} onClick={this.handleSortTable}> Admin </th>
		      <th id='hdr.9' width="60px"> Actions </th>
				</tr>
			</thead>

			{this.displayTable()}
			</table>

			</div>
			</div>
		);
	}

	displayTable() {
		if (this.state.operations.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucune opération</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.operations.map(this.createTableRow)}
				</tbody>
			)
		}
	}

	displayPagination(pager) {
		return (
      <ul className="pagination">
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(1)}>{"<<"}</a>
        </li>
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
        </li>
        {pager.pages.map((page, index) =>
  	      <li key={index} className={pager.currentPage === page ? 'active' : ''}>
	          <a onClick={() => this.setPage(page)}>{page}</a>
    	    </li>
        )}
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
        </li>
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
        </li>
      </ul>
		);
	}

  createTableRow(oper, operIdx) {
  	var trClass = "stateloListItemPointer ";
  	if (oper.deleted) {
  		trClass += "qbooksDeletedOper";
  	}

  	var userShortname = oper.user;
  	cstQBooksAdmins.forEach(cqba => {
  		if (cqba.user === oper.user) {
  			userShortname = cqba.shortname;
  		}
  	});


    return (
      <tr key={'oper.' + operIdx} onDoubleClick={this.handleAddEditOperationClick.bind(this, oper)} 
      	className={trClass}>
        <td>{this.zeropad(oper.operIdx, CST_IDX_PADDING_SIZE)}</td>
        <td>{moment(oper.date).utc().format('YYYY-MM-DD')}</td>
        <td>{oper.playerName}</td>
        <td>{oper.type.charAt(0).toUpperCase() + oper.type.slice(1)}</td>
        <td>{oper.leagueName}<br/>{oper.seasonName}</td>
        <td className="text-right">{oper.debit.toFixed(2) + " $"}</td>
        <td className="text-right">{oper.credit.toFixed(2) + " $"}</td>
        <td className="cellPaddingLeft">{oper.notes}</td>
        <td className="">{userShortname}</td>
        <td>
        	<span className="btn-sm2 editIcon" onClick={this.handleAddEditOperationClick.bind(this, oper)}>
        		<i className="fa fa-pencil-square-o"></i>
        	</span>

        	{oper.deleted ?
	        	<span className="btn-sm2 editIcon2" onClick={this.handleDeleteOperationClick.bind(this, oper)}>
	        		<i className="fa fa-plus"></i>
	        	</span>
	        	:
		        <span className="btn-sm2 editIcon2" onClick={this.handleDeleteOperationClick.bind(this, oper)}>
	        		<i className="fa fa-trash-o"></i>
	        	</span>
        	}
        </td>
      </tr>
    );
  }

	dispDateFilterA() {
		return (
			<div className="col-md-4 col-sm-6 col-12">
				<span className="small">Date de début</span><br/>
				<input type="date" className="form-control form-control-sm input-sm" name="dateA" id="dateA" 
					value={this.state.dataFilters.dateA || ''} onChange={this.handleDateAChange} onBlur={this.handleDateABlur}/>
			</div>
		)
	}

	dispDateFilterB() {
		return (
			<div className="col-md-4 col-sm-6 col-12">
				<span className="small">Date de fin</span><br/>
				<input type="date" className="form-control form-control-sm input-sm" name="dateB" id="dateB"
					value={this.state.dataFilters.dateB || ''} onChange={this.handleDateBChange} onBlur={this.handleDateBBlur}/>
			</div>
		)		
	}

	dispOperFilter() {
		return (
      <div className="col-md-4 col-sm-6 col-12">
				<span> Opération </span> <br/>
	  		<select className="form-control form-control-sm input-sm" name="type" id="type" 
	  			value={this.state.dataFilters.type} onChange={this.handleOperChange}>
						<option value={''} key={'otype0'} ></option>
	  				{this.state.operTypes.map(this.optOperTypes)}
				</select>
			</div>
		)
	}

	dispLeagueFilter() {
		return (
      <div className="col-md-4 col-sm-6 col-12">
				<span> Ligue / Compte </span> <br/>
	  		<select className="form-control form-control-sm input-sm" name="type" id="type" 
	  			value={this.state.dataFilters.leagueId} onChange={this.handleLeagueChange}>
						<option value={0} key={'opt0'}></option>
						{this.state.leagues.map(lg => (
							<option value={lg._id} key={lg._id}>{lg.name}</option>
						))}				
				</select>
			</div>
		)
	}

	dispSeasonFilter() {
		return (
      <div className="col-md-4 col-sm-6 col-12">
				<span> Saison (choisir la ligue d'abord) </span> <br/>
	  		<select className="form-control form-control-sm input-sm" name="type" id="type" 
	  			value={this.state.dataFilters.seasonId} onChange={this.handleSeasonChange}>
						<option value={0} key={'opt0'}></option>
						{this.state.seasons.map(season => (
							<option value={season._id} key={season._id}>{season.name}</option>
						))}				
				</select>
			</div>
		)
	}

	dispNotesFilter() {
		return (
      <div className="col-md-4 col-sm-6 col-12">
				<span> Notes </span> <br/>
	  		<input className="form-control form-control-sm input-sm" name="notes" id="notes" 
	  			value={this.state.dataFilters.notes} onChange={this.handleNotesChange}>
				</input>
			</div>
		)
	}

	optOperTypes(ot, otidx, opertypes) {
		return (
			<option value={ot} key={'ot.' + otidx}> {ot.charAt(0).toUpperCase() + ot.slice(1)} </option>
		)
	}

	dispPlayerSearch() {
		//console.log('QvneaBooks: dispPlayerSearch')
		return (
      <div className="col-md-4 col-sm-6 col-12">
				<span> Joueur </span> <br/>
				<AutoSuggestPlayer playerId={this.state.dataFilters.playerId} 
					dataChange={this.handlePlayerChange} onBlur={this.handlePlayerOnBlur}/>
			</div>
		)
	}

	handleDateAChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.dateA = e.target.value;
    this.setState({
    	dataFilters: dataFilters
    });
	}
	handleDateBChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.dateB = e.target.value;
    this.setState({
    	dataFilters: dataFilters
    });
	}
	handleDateABlur(e) {
		var newDateA = e.target.value;
		if (!this.isDateValid(newDateA) || moment(newDateA).isAfter(this.state.dataFilters.dateB)) {
			this.setState({dateA: this.state.prevValidDateA});
		}
	}
	handleDateBBlur(e) {
		var newDateB = e.target.value;
		if (!this.isDateValid(newDateB) || moment(newDateB).isBefore(this.state.dataFilters.dateA)) {
			this.setState({dateB: this.state.prevValidDateB});
		}
	}

	handlePlayerChange(dataValue) {
		//console.log('handlePlayerChange')
		//console.log(dataValue)
		var dataFilters = this.state.dataFilters;
		dataFilters.playerId = dataValue;
    this.setState({
    	dataFilters: dataFilters
    });
	}

	handlePlayerOnBlur(dataValue) {
		if (dataValue === '') {
			var dataFilters = this.state.dataFilters;
			dataFilters.playerId = "0";
	    this.setState({dataFilters: dataFilters});
		}
	}

	handleOperChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.type = e.target.value;
    this.setState({
    	dataFilters: dataFilters
    });
	}

	handleLeagueChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.leagueId = e.target.value;
		this.loadSeasons();
    this.setState({
    	dataFilters: dataFilters
    });
	}

	handleSeasonChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.seasonId = e.target.value;
    this.setState({
    	dataFilters: dataFilters
    });
	}

	handleNotesChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.notes = e.target.value;
    this.setState({
    	dataFilters: dataFilters
    });
	}

	handleShowDeletedChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.showDeleted = e.target.checked;
    this.setState({
    	dataFilters: dataFilters
    });
	}

	handleApplyFilters() {
		var dataFilters = this.state.dataFilters;

		if (dataFilters.playerId !== '0') {
			localStorage.setItem('filtPlayerId', dataFilters.playerId);
		}

		dataFilters.filteredResults = true;
		this.setState({dataFilters: dataFilters});
    this.initiatePagerSizeWithData(dataFilters, false);
	}

	handleResetFilters() {
		var dataFilters = {
			filteredResults: false,
			dateA: "",
			dateB: "",
			playerId: "0",
			type: "",
			leagueId: "0",
			seasonId: "0",
			notes: "",
			showDeleted: false,
		};

		localStorage.removeItem('filtPlayerId');
		this.setState({dataFilters: dataFilters});
    this.initiatePagerSizeWithData(dataFilters, true);		
	}

	handleAddEditOperationClick(operItem) {
	 	//console.log('handleAddEditOperationClick');
	 	//console.log(operItem)

		// new operation ?
		var modalOperation = {};
		if (operItem._id === '0') {

			var myDate = new Date();
			myDate.setUTCHours(12,0,0,0);

			// add operation
			modalOperation = {
				_id: operItem._id,
				date: myDate,
				playerId: '0',
				playerIdTx: '0',
				type: '',
				leagueId: '0',
				seasonId: '0',
				leagueIdTx: '0',
				seasonIdTx: '0',
				debit: '0',
				credit: '0',
				notes: '',
				deleted: false,
				user: this.context.connectedUser.user.name
			};
			this.setState({
				modalOperation: modalOperation,
				showQvneaBooksEditModal: true
			});

		} else {
			// edit operation
			modalOperation = JSON.parse(JSON.stringify(operItem));
			
			// overwrite user
			modalOperation.user = this.context.connectedUser.user.name;

			this.setState({
				modalOperation: modalOperation,
				showQvneaBooksEditModal: true
			});
		}
	}

	handleDeleteOperationClick(operItem) {
	 	var theWord = "supprimer";
	 	if (operItem.deleted) {
	 		theWord = "restaurer";
	 	}
		
		var confirmAns = window.confirm("Voulez-vous vraiment " + theWord + " l'opération suivante: \n" + 
			"#: " + this.zeropad(operItem.operIdx, CST_IDX_PADDING_SIZE) + "\n" + 
			"Date: " + moment(operItem.date).utc().format('YYYY-MM-DD') + "\n" + 
			"Joueur: " + operItem.playerName + "\n" + 
			"Opération: " + operItem.type + "\n" +
			"Ligue: " + operItem.leagueName + "\n" +
			"Débit: " + operItem.debit.toFixed(2) + " $" + "\n" + 
			"Crédit: " + operItem.credit.toFixed(2) + " $" + "\n" + 
			"Note: " + operItem.notes);
	
		var state = !operItem.deleted;

		if (confirmAns) {
			// Save to DB
			Axios.post('/api/qvneaBooks' + 
				'/setDeletedState/' + operItem._id + 
				'/state/' + state)
			.then(response => {
			 	this.reloadData();
			})
			.catch(function(error) {
				console.log(error);
			});     
		}

	}

	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortParams.sortOrder;
		var sortFieldIdx = this.state.sortParams.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[colIdx];
		}

		var sortClass = [];
		for(var i = 0; i < (TABLE_NBCOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		var sortParams = {
			sortFieldIdx: colIdx,
			sortOrder: sortOrder,
			sortClass: sortClass
		};

		this.setPage(this.state.pager.currentPage, this.state.pager, sortParams);
	}

	handleModalCancel() {
		this.setState({ 
			showQvneaBooksEditModal: false
		});
	}

	handlePageSizeChange(e) {
		var pager = this.state.pager;
		pager.pageSize = parseInt(e.target.value);
		this.setPage(1, pager, this.state.sortParams);
	}

	handleShowProcedure(e) {
		const path = '/files/Procedure de gestion QVNEA Books.pdf';
		window.open(path);
	}

	handleDownloadOperationsCSV(e) {
		const path = '/qvnea/qvnea-books/csv';
		this.props.navigate(path);	
	}

	isDateValid(dateVal) {
		var dateIsValid = false;
		var minValidDate = moment(new Date("2001-01-01"));
		var maxValidDate = moment(new Date("2199-12-31"));
		if ((dateVal === '') || (
			  moment(new Date(dateVal)).isSameOrAfter(minValidDate) && 
				moment(new Date(dateVal)).isSameOrBefore(maxValidDate))) {
			dateIsValid = true;
		}
		return dateIsValid;
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	zeropad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
	}

}

export default withRouter(QvneaBooksOperations);
